/**
 * Resign asks before it resigns — decision D4, the old screen's pattern
 * ("Are you sure you want to resign?" / No / Yes, `BottomControlsComponent`
 * L156-173).
 *
 * This REPLACES M1a's hold-to-confirm ring (design 04h). Two reasons, both from
 * the parity review: a 600 ms hold is an invisible affordance where the old
 * screen asks out loud, and Abort — the other destructive control, one tile
 * away — never had the ring at all, so the two behaved differently.
 *
 * The dialog's open flag is local state in the View because it is pure
 * presentation; the only thing the model owns is the action.
 */
import React, {useCallback, useState} from 'react';

import {ConfirmDialog, Tile} from '../../../../ui';
import {ResignTileModel} from './ResignTile.model';

/** BottomControlsComponent L159, verbatim. */
export const RESIGN_CONFIRM_COPY = 'Are you sure you want to resign?';

export default React.memo(function ResignTileView({
  gameOver,
  showAbort,
  resign,
}: ResignTileModel) {
  const [asking, setAsking] = useState(false);

  const onCancel = useCallback(() => setAsking(false), []);
  const onConfirm = useCallback(() => {
    setAsking(false);
    resign();
  }, [resign]);

  // L143: before the first move the legal action is Abort, not Resign.
  if (showAbort) {
    return null;
  }

  return (
    <>
      <Tile
        icon="resign"
        label="Resign"
        tone="danger"
        disabled={gameOver}
        onPress={gameOver ? undefined : () => setAsking(true)}
      />
      <ConfirmDialog
        testID="v2-confirm-resign"
        visible={asking}
        title={RESIGN_CONFIRM_COPY}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </>
  );
});
